var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgInbox = function SvgInbox(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "current",
    d: "M16.667.5H3.333A3.343 3.343 0 0 0 0 3.833v8.334C0 14 1.5 15.5 3.333 15.5h13.334C18.5 15.5 20 14 20 12.167V3.833C20 2 18.5.5 16.667.5M18 5.333 11.417 9.75c-.417.25-.917.417-1.417.417S9 10 8.583 9.75L2 5.333c-.333-.25-.417-.75-.167-1.166.25-.334.75-.417 1.167-.167l6.583 4.417c.25.166.667.166.917 0L17.083 4c.417-.25.917-.167 1.167.25.167.333.083.833-.25 1.083"
  })));
};
export default SvgInbox;